import dateDiffInDays from '~/src/utils/dateDiff'

export function dateDiff(item)
{
	const now = new Date
	const diff = Math.abs( dateDiffInDays( now, new Date(item.created_at) ) )

	if (diff < 1)
		return 'today'
	if (diff < 2)
		return 'yersterday'
	if (diff < 7 )
		return Math.floor(diff) + ' days ago'
	if (diff < 30 && diff / 7 >= 1 )
		return Math.floor(diff / 7) + ' weeks ago'
	if (diff >= 30 && diff / 30 >= 1 )
		return Math.floor(diff / 30) + ' months ago'
}

export function day(date)
{
	if (!date)	return '';
	return date.getDate()
}

export function year(date)
{
	if (!date)	return '';
	return date.getFullYear()
}

export function digitDate(theDate)
{
	// debugger;
	if (!theDate)	return '';
	var date = new Date(theDate);
	var dd = date.getDate();
	var mm = date.getMonth() + 1; //January is 0!

	var yyyy = date.getFullYear();

	// return `${dd < 10 ? '0'+dd : dd}.${mm < 10 ? '0'+mm : mm}.${yyyy}`;
	return `${dd < 10 ? '0'+dd : dd}/${mm < 10 ? '0'+mm : mm}/${yyyy}`;
}

export function isUpcomingDate(aDate)
{
	const now = getDaysTotal() - 5;
	const days = getDaysTotal(aDate);
	return (days >= now);

	// const now = Date.now();
	// let timestamp = new Date(aDate).getTime() ;//* 1000;
	// return (timestamp >= now)
}

export function getDaysTotal(aDate)
{
	let date = aDate && new Date(aDate) || new Date();
	let dd = date.getDate();
	let mm = date.getMonth(); //January is 0!
	let yyyy = date.getFullYear();

	return (yyyy*366 + mm*31 + dd)
}

export function upcomingDate(list)
{
	if (!list)	return null;

	// console.log(list)
	let today = new Date();
	today.setDate(today.getDate() - 5);
	// const now = Date.now();
	const now = today.getTime();
	let closestDate = null;
	let closestTimestamp = null;
	for (let i = 0; i < list.length; i++)
	{
		// let timestamp = parseInt(list[i].date) ;//* 1000;
		let timestamp = new Date(list[i].date).getTime() ;//* 1000;
		if (timestamp >= now)
		{
			if (!closestTimestamp)
			{
				closestTimestamp = timestamp;
				closestDate = new Date( timestamp );
			}
			// Does not assume that the date array will be sorted
			if (timestamp < closestTimestamp)
			{
				closestDate = new Date( timestamp );
			}
			// let date = new Date( timestamp );
			// return date;
			// // let date = new Date( parseInt(list[i].date) * 1000 );
		}
	}

	return closestDate;
}

export function lastDate(list)
{
	if (!list || list.length == 0)	return null;

	// console.log(list)
	let latestIdx = 0;
	let latest = new Date(list[0].date).getTime();
	// let dates = [...list];
	// dates.sort((a, b) =>
	// {

	// })
	for (let i = 1; i < list.length; i++)
	{
		// let timestamp = parseInt(list[i].date) ;//* 1000;
		let timestamp = new Date(list[i].date).getTime() ;//* 1000;
		if (timestamp >= latest)
		{
			latestIdx = i;
			latest = timestamp;
		}
	}

	return list[latestIdx].date;
}


export default {
	methods:
	{

		dateDiff,

		day,

		month(date)
		{
			if (!date)	return '';
			return new Intl.DateTimeFormat(this.lang, { month: 'long' }).format( date )
			// return new Intl.DateTimeFormat(this.lang, { month: 'long' }).format( date.getMonth() )
		},

		year,

		digitDate,

		isUpcomingDate,

		upcomingDate,

		lastDate,
	}
}
